import '../scss/style.scss';
import './sidebar';
import './ttl_animation';
import './schedule';
import { Splide } from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import Lenis from '@studio-freight/lenis';
import matchHeight from 'jquery-match-height';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const lenis = new Lenis({
  duration: 0,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  orientation: 'vertical',
  gestureOrientation: 'vertical',
  smoothWheel: true,
  smoothTouch: false,      // タッチデバイスではスムース効果を無効化
  touchMultiplier: 2,
  wheelMultiplier: 0.8,    // より自然な感じに調整
  lerp: 0.1,              // より滑らかな補間
  infinite: false
});

// Lenisの更新をrAFに同期
function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}

// スクロールの状態を監視（オプション）
lenis.on('scroll', ({ scroll, limit, velocity, direction, progress }) => {
  // console.log({ scroll, limit, velocity, direction, progress })
});

// アニメーションを開始
requestAnimationFrame(raf);

// カウントダウンの設定
if(document.getElementById("count")) {
  let count = 0;
  const countElement = document.getElementById("count");
  const loadingScreen = document.getElementById("loading-screen");
  // const loadingLogoImg = document.querySelector('.homeLoading-box__imgBox');
  const flipFront = document.querySelector('.flip-front')
  const flipBack = document.querySelector('.flip-back');
  function updateCount() {
    countElement.textContent = count;
    if (count < 100) {
      count++;
      setTimeout(updateCount, 10);
    }
    else {
      setTimeout(() => {
        // 両方の要素を同時に回転させる
        flipFront.classList.add('is-flip');
        flipBack.classList.add('is-flip');
        countElement.style.opacity="0"
        countElement.style.transition="0.6s"
      }, 1600);

      setTimeout(() => {
        loadingScreen.classList.add("is-fadeout");
      }, 2600);
    }
  }
  // ページ読み込み後にカウント開始
  document.addEventListener('DOMContentLoaded', function() {
    updateCount();
  });
}



$(function(){
  $('a[href^="#"]').click(function(){
    // サイドバーのリンクをクリックの場合はオフセットを20pxにする
    if ($(this).closest('.js-sidebar-click').length) {
      var heightAdjust = 20;
    } else {
      var heightAdjust = 0;
    }
    var headerHeight = $('.l-header').outerHeight();
    var adjust = -headerHeight - heightAdjust;
    var speed = 400;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top + adjust;
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
  });
});

// SP menu
$(function() {
	$('.js-nav-btn').on('click',function() {
		$('.js-nav').toggleClass('is-open');
		$(this).toggleClass('is-close');
	});
	$('.js-nav a[href^="#"]').on('click',function() {
		$('.js-nav').removeClass('is-open');
		$('.js-nav-btn').removeClass('is-close');
	});
});

// sub menu
if( 768 <= window.innerWidth ) {
  $('.js-nav-parent').on('mouseenter', function() {
    $(this).children('.js-nav-child').stop().fadeIn(200);
    $(this).addClass('is-open');
    $('.js-nav-child').not($(this).children('.js-nav-child')).stop().fadeOut(200);
  });
  $('.js-nav-parent').on('mouseleave', function() {
    $(this).removeClass('is-open');
    $('.js-nav-child').stop().fadeOut(200);
  });
} else {
  $('.js-nav-parent').on('click', function() {
    $(this).children('.js-nav-child').stop().slideToggle(200);
    $(this).toggleClass('is-open');
    $('.js-nav-parent').not(this).removeClass('is-open');
    $('.js-nav-child').not($(this).children('.js-nav-child')).stop().slideUp(200);
  });
}


/*	home
============================================================================================================*/
document.addEventListener( 'DOMContentLoaded', function() {

	// js-home-topics-slider
	if(document.getElementsByClassName('js-home-topics-slider').length) {
		var jsHomeTopicsSlider_option	=	{
      type					:	'loop',
      fixedWidth		:	'auto',
      gap						:	'100px',
      arrows				:	false,
      pagination		: false,
      autoScroll: {
        speed					:	.8,
      },
      breakpoints		:	{
        767	: {
          gap						:	'40px',
          autoScroll: {
            speed					:	.4,
          },
        },
      },
    },
    jsHomeTopicsSlider = new Splide( '.js-home-topics-slider', jsHomeTopicsSlider_option );
		jsHomeTopicsSlider.mount( { AutoScroll } );
	}
});

window.addEventListener( 'load', function() {
	// js-home-bnr-slider
	if(document.getElementsByClassName('js-home-bnr-slider').length) {
		var bnrSlideCount = document.querySelectorAll('.js-home-bnr-slider .splide__slide').length;
		var bnrIsLoop = bnrSlideCount >= 3;
		var jsHomeBnrSlider_option = {
					type          : bnrIsLoop ? 'loop' : 'slide',
					rewind        : false,
					focus         : bnrIsLoop ? 'center' : 0,
					fixedWidth    : '632px',
					gap           : '30px',
					speed         : 1000,
					arrows        : false,
					autoplay      : bnrIsLoop,
					interval      : 3000,
					autoplaySpeed : 0,
					breakpoints   : {
						767 : {
							fixedWidth : '330px',
							gap        : '10px',
						},
					},
				};
		if ( !bnrIsLoop ) {
			var bnrCW  = document.querySelector('.js-home-bnr-slider').offsetWidth;
			var bnrTW  = bnrSlideCount * 632 + Math.max( 0, bnrSlideCount - 1 ) * 30;
			var bnrPad = Math.max( 0, Math.floor( ( bnrCW - bnrTW ) / 2 ) );
			jsHomeBnrSlider_option.padding = { left: bnrPad + 'px', right: bnrPad + 'px' };
		}
		var jsHomeBnrSlider = new Splide( '.js-home-bnr-slider', jsHomeBnrSlider_option );
		jsHomeBnrSlider.mount();
	}
});

document.addEventListener( 'DOMContentLoaded', function() {
	// js-home-players-slider
	if(document.getElementsByClassName('js-home-players-slider').length) {
		var jsHomePlayersSlider_option	=	{
					type					:	'loop',
					rewind				:	true,
					focus					:	'center',
					gap						:	'24px',
					speed					:	1000,
					fixedWidth		:	'856px',
					pagination		:	false,
					autoplay			:	true,
          arrows: true,
					breakpoints		:	{
						767	: {
							fixedWidth		:	'min(100% - 40px, 350px)',
							gap						:	'10px',
						},
					},
				},
    jsHomePlayersSlider = new Splide( '.js-home-players-slider', jsHomePlayersSlider_option );
		jsHomePlayersSlider.mount();

    // 次のスライドが表示されるタイミングで発生
    jsHomePlayersSlider.on("active", function () {
      slideIndex();
    });
    function slideIndex() {
      // 現在のスライドが何枚目かを取得
      document.querySelector(".js-home-players-counter__current").textContent = jsHomePlayersSlider.index + 1;
      // スライドの総数を取得
      document.querySelector(".js-home-players-counter__total").textContent = jsHomePlayersSlider.length;
    }
    slideIndex();
	}

  // js-matchheight
  if(document.getElementsByClassName('js-matchheight').length) {
    $('.js-matchheight').matchHeight();
  }

  // ふわっとと下から表示
  gsap.registerPlugin(ScrollTrigger);
  const fadeupElements = document.querySelectorAll('.js-fadeup');

  if (fadeupElements.length) {
    fadeupElements.forEach((element) => {
      gsap.set(element, {
        opacity: 0,
        y: 50
      });
      ScrollTrigger.create({
        trigger: element,  // 個別の要素をトリガーに
        start: 'top bottom 10%',  // 画面下端から100px上に入ったら開始
        end: 'bottom top 10%',
        onEnter: () => {
          gsap.to(element, {  // 個別の要素をアニメーション
            opacity: 1,
            y: 0,
            duration: 0.5,
            ease: 'ease-out',
          });
          element.classList.add('is-delay');
        }
      });
    });
  }
});

			var getDevice = (function(){
				var ua = navigator.userAgent;
				if(ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0){
					return 'sp';
				}else if(ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0){
					return 'tab';
				}else{
					return 'other';
				}
			})();

			if( getDevice == 'sp' ){
				document.write('<meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover">');
			}else if( getDevice == 'tab' ){
				document.write('<meta name="viewport" content="width=1280">');
        document.body.classList.add('tabletSize');
			}else if( getDevice == 'other' ){
				document.write('<meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover">');
			}